// Our main CSS
import '../css/app.css'
import { createApp } from 'vue'
/**
 * Vue is ready for you, if you need it.
 */

import { ModuleManager } from './moduleManager'
import { initDownloadTracking } from './modules/footerForm'

// Create and configure module manager
const moduleManager = new ModuleManager()// Register all modules with their selectors
moduleManager
  .register('.js-hero', 'hero')
  .register('.js-logos', 'logos')
  .register('.js-quote-slider', 'quoteSlider')
  .register('.js-footer-form', 'footerForm')
  .register('.js-pricing-cards', 'pricing')
  .register('.js-faq', 'faq')
  .register('.js-feature-slider', 'featureSlider')
  .register('.js-show-superoffice', 'superoffice')
  .register('.js-show-hubspot-modal', 'hubspotModal')
  .register('.js-hubspot-form', 'hubspotForm')
  .register('.js-module-builder', 'moduleBuilder')

  .registerAdmin('Hero', 'hero')
  .registerAdmin('Logos', 'logos')
  .registerAdmin('QuoteSlider', 'quoteSlider')
  .registerAdmin('Pricing', 'pricing')
  .registerAdmin('Faq', 'faq')
  .registerAdmin('FeatureSlider', 'featureSlider')

// Initialize modules
moduleManager.init()

// Initialize download tracking
initDownloadTracking()


let menu = document.getElementById('js-vue-menu')
const menuApp = createApp({
  data() {
    return {
      active: false,
      mobileMenuActive: false
    }
  },
  methods: {
    showSubMenu(subMenu) {
      this.active = subMenu
    },
    toggleMobileMenu() {
      this.mobileMenuActive = !this.mobileMenuActive
      document.body.classList.toggle('overflow-hidden', this.mobileMenuActive)
    },
    resetSubMenu() {
      this.active = false
    },
  }
})
menuApp.mount(menu)